import "./ConfigurationPage.scss";
import ConfigurationPage from "./ConfigurationPage.jsx";

export default ConfigurationPage;
